import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { priceLabel, SectionLabel } from "@/components/public/common";
import { PageHero } from "./Services";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

export default function Pricing() {
  const { data: pricing } = useQuery({ queryKey: ["pricing"], queryFn: () => api.get("/pricing").then(r => r.data.pricing) });
  const cats = [...new Set((pricing || []).map(p => p.category))];
  const [active, setActive] = useState("all");
  const filtered = (pricing || []).filter(p => active === "all" || p.category === active);

  return (
    <div>
      <PageHero label="Pricing" title="Honest, upfront pricing" subtitle="All pricing is set by Thomason Digital Works and kept current. Final estimates may change after our team reviews your specific needs." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="flex flex-wrap gap-2 mb-8">
          {["all", ...cats].map((c) => (
            <button key={c} onClick={() => setActive(c)} data-testid={`pricing-filter-${c.replace(/ /g, "-")}`}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${active === c ? "bg-electric text-white" : "border border-slate-200 text-slate-600 hover:border-electric"}`}>
              {c === "all" ? "All" : c}
            </button>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map((p) => (
            <div key={p.id} data-testid={`pricing-card-${p.id}`} className={`rounded-xl p-6 relative ${p.featured ? "border-2 border-electric shadow-lg" : "border border-slate-200"}`}>
              {p.featured && <span className="absolute -top-3 left-6 bg-electric text-white text-[10px] font-mono uppercase tracking-wider px-2 py-0.5 rounded-full">Popular</span>}
              <span className="text-[10px] font-mono uppercase tracking-wider text-metallic">{p.category}</span>
              <h3 className="font-heading font-semibold text-lg text-navy mt-1">{p.packageName}</h3>
              <p className="mt-2 text-3xl font-heading font-bold text-navy">{priceLabel(p)}</p>
              {p.billingFrequency === "monthly" && <span className="text-xs text-slate-500">per month</span>}
              <p className="mt-2 text-sm text-slate-600">{p.description}</p>
              <ul className="mt-4 space-y-1.5">
                {(p.features || []).map((f, i) => <li key={i} className="flex gap-2 text-sm text-slate-700"><CheckCircle2 className="h-4 w-4 text-electric shrink-0 mt-0.5" /> {f}</li>)}
              </ul>
              <Link to={p.ctaLink || "/request-service"}><Button className="w-full mt-5 bg-electric hover:bg-tech">{p.ctaText || "Get Started"}</Button></Link>
            </div>
          ))}
        </div>
        <p className="mt-8 text-sm text-slate-500">Discounts available for seniors, veterans, and teachers (10%). Free estimates for approved Salem & Centralia service areas. Discounts are not combined unless approved.</p>
      </section>
    </div>
  );
}
